const ErrorMessages = {
	error_general: {
		title: "MESSAGES_ERROR_GENERAL_TITLE",
		button_text: "MESSAGES_ERROR_GENERAL_BUTTON",
		text: "MESSAGES_ERROR_GENERAL_TEXT",
		key: "error_general",
	},
	error_fatal: {
		title: "MESSAGES_ERROR_GENERAL_TITLE",
		text: "MESSAGES_ERROR_GENERAL_TEXT",
		key: "error_fatal",
	},
	number_already_booked: {
		title: "MESSAGES_NUMBER_ALREADY_BOOKED_TITLE",
		button_text: "MESSAGES_NUMBER_ALREADY_BOOKED_BUTTON",
		text: "MESSAGES_NUMBER_ALREADY_BOOKED_TEXT",
		key: "number_already_booked",
		ctas: ["ok_clear_error_get_status"],
	},
	// error_code_expired: {
	// 	title: "MESSAGES_ERROR_CODE_EXPIRED_TITLE"],
	// 	button_text: "MESSAGES_ERROR_CODE_EXPIRED_BUTTON"],
	// 	text: "MESSAGES_ERROR_CODE_EXPIRED_TEXT"],
	// 	key: "error_code_expired"
	// },
	// error_code_general: {
	// 	title: "MESSAGES_ERROR_CODE_GENERAL_TITLE"],
	// 	button_text: "MESSAGES_ERROR_CODE_GENERAL_BUTTON"],
	// 	text: "MESSAGES_ERROR_CODE_GENERAL_TEXT"],
	// 	key: "error_code_general"
	// },
	error_code_expired_simple: {
		title: "MESSAGES_ERROR_CODE_EXPIRED_TITLE",
		button_text: "",
		text: "MESSAGES_ERROR_CODE_EXPIRED_TEXT",
		key: "error_code_expired_simple",
	},

	login_credentials_error: {
		title: "MESSAGES_ERROR_WRONG_EMAIL_OR_PASSWORD_TEXT",
		button_text: "",
		text: "",
		key: "login_credentials_error",
	},

	payment_error_failed: {
		title: "MESSAGES_PAYMENT_ERROR_FAILED_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_FAILED_TEXT",
		key: "payment_error_failed",
		ctas: ["change_card"],
	},
	payment_error_transaction_failed: {
		title: "MESSAGES_PAYMENT_ERROR_TRANSACTION_FAILED_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_TRANSACTION_FAILED_TEXT",
		key: "payment_error_transaction_failed",
		ctas: ["change_card"],
	},
	payment_error_incorrect_details: {
		title: "MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TEXT",
		key: "payment_error_incorrect_details",
		ctas: ["retry_payment"],
	},
	payment_error_incorrect_details_temp_issue: {
		title: "MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TEMP_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TEMP_TEXT",
		key: "payment_error_incorrect_details_temp_issue",
		ctas: ["change_card", "retry_payment"],
	},
	payment_error_incorrect_cvv: {
		title: "MESSAGES_PAYMENT_ERROR_INCORRECT_CVV_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_INCORRECT_CVV_TEXT",
		key: "payment_error_incorrect_cvv",
		ctas: ["change_card", "retry_payment"],
	},
	payment_error_transaction_declined: {
		title: "MESSAGES_PAYMENT_ERROR_TRANSACTION_DECLINED_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_TRANSACTION_DECLINED_TEXT",
		key: "payment_error_transaction_declined",
		ctas: ["change_card"],
	},
	payment_error_insufficient: {
		title: "MESSAGES_PAYMENT_ERROR_INSUFFICIENT_FUNDS_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_INSUFFICIENT_FUNDS_TEXT",
		key: "payment_error_insufficient",
		ctas: ["change_card", "retry_payment"],
	},
	payment_error_fraud: {
		title: "MESSAGES_PAYMENT_ERROR_FRAUD_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_FRAUD_TEXT",
		key: "payment_error_fraud",
		ctas: ["change_card"],
	},
	payment_error_general: {
		title: "MESSAGES_PAYMENT_ERROR_GENERAL_TITLE",
		text: "MESSAGES_PAYMENT_ERROR_GENERAL_TEXT",
		key: "payment_error_general",
		ctas: ["change_card"],
	},

	non_eligible_card: {
		title: "non_eligible_card",
		text: "MESSAGES_PAYMENT_ERROR_GENERAL_TEXT",
		key: "payment_error_general",
		ctas: ["change_card"],
	},

	non_recurring_card: {
		title: "non_recurring_card",
		text: "MESSAGES_PAYMENT_ERROR_GENERAL_TEXT",
		key: "payment_error_general",
		ctas: ["change_card", "continue_payment"],
	},

	// payment_error_declined: {
	// 	title: "MESSAGES_PAYMENT_ERROR_DECLINED_TITLE"],
	// 	button_text: "MESSAGES_PAYMENT_ERROR_DECLINED_BUTTON"],
	// 	text: "MESSAGES_PAYMENT_ERROR_DECLINED_TEXT"],
	// 	key: "payment_error_declined"
	// },

	// code_resent: {
	// 	title: "MESSAGES_CODE_RESENT_TITLE"],
	// 	button_text: "MESSAGES_CODE_RESENT_BUTTON"],
	// 	text: "MESSAGES_CODE_RESENT_TEXT"],
	// 	key: "code_resent"
	// },
	// sms_sent: {
	// 	title: "MESSAGES_SMS_SENT_TITLE"],
	// 	button_text: "MESSAGES_SMS_SENT_BUTTON"],
	// 	text: "MESSAGES_SMS_SENT_TEXT"],
	// 	key: "sms_sent"
	// },
	captcha_error: {
		title: "MESSAGES_CAPTCHA_ERROR_TITLE",
		button_text: "MESSAGES_CAPTCHA_ERROR_BUTTON",
		text: "MESSAGES_CAPTCHA_ERROR_TEXT",
		key: "captcha_error",
	},
	nonce_error: {
		title: "MESSAGES_NONCE_ERROR_TITLE",
		button_text: "MESSAGES_NONCE_ERROR_BUTTON",
		text: "MESSAGES_NONCE_ERROR_TEXT",
		key: "nonce_error",
	},
	// sms_error: {
	// 	title: "MESSAGES_SMS_ERROR_TITLE"],
	// 	button_text: "MESSAGES_SMS_ERROR_BUTTON"],
	// 	text: "MESSAGES_SMS_ERROR_TEXT"],
	// 	key: "sms_error"
	// },
	number_expired: {
		title: "MESSAGES_NUMBER_EXPIRED_TITLE",
		button_text: "MESSAGES_NUMBER_EXPIRED_BUTTON",
		text: "MESSAGES_NUMBER_EXPIRED_TEXT",
		key: "number_expired",
		ctas: ["ok_clear_error_get_status"],
	},
	password_already_set: {
		title: "MESSAGES_PASSWORD_ALREADY_SET_TITLE",
		button_text: "MESSAGES_PASSWORD_ALREADY_SET_BUTTON",
		text: "MESSAGES_PASSWORD_ALREADY_SET_TEXT",
		key: "password_already_set",
	},
	number_not_activated: {
		title: "MESSAGES_NUMBER_NOT_ACTIVATED_TITLE",
		button_text: "MESSAGES_NUMBER_NOT_ACTIVATED_BUTTON",
		text: "MESSAGES_NUMBER_NOT_ACTIVATED_TEXT",
		key: "number_not_activated",
		ctas: ["reset_mnp"],
	},
	number_in_transfer: {
		title: "MESSAGES_NUMBER_IN_TRANSFER_TITLE",
		button_text: "MESSAGES_NUMBER_IN_TRANSFER_BUTTON",
		text: "MESSAGES_NUMBER_IN_TRANSFER_TEXT",
		key: "number_not_activated",
		show_in_modal: true,
		ctas: ["reset_mnp"],
	},
	wrong_operator: {
		title: "MESSAGES_WRONG_OPERATOR_TITLE",
		button_text: "MESSAGES_WRONG_OPERATOR_BUTTON",
		text: "MESSAGES_WRONG_OPERATOR_TEXT",
		key: "wrong_operator",
		show_in_modal: true,
		ctas: ["reset_mnp"],
	},
	account_activated: {
		title: "MESSAGES_ERROR_ACC_ACTIVATED_TITLE",
		button_text: "MESSAGES_ERROR_ACC_ACTIVATED_CTA",
		text: "MESSAGES_ERROR_ACC_ACTIVATED_TEXT",
		key: "account_activated",
		ctas: ["account_activated"]
	},
		session_error: {
		title: "MESSAGES_ERROR_GENERAL_TITLE",
		button_text: "MESSAGES_ERROR_GENERAL_BUTTON",
		text: "MESSAGES_ERROR_SESSION_ERROR_TEXT",
		key: "session_error",
	},
};

 export default ErrorMessages;